<div class="main-card shadow-sm">
  <!-- Header -->
  <div class="d-flex justify-content-between align-items-center mb-3">
    <div class="d-flex align-items-center gap-2">
      <fa-icon [icon]="faCartShopping" class="text-blue" style="font-size: 14px;"></fa-icon>
      <span class="main-heading fw-smbold">Purchases</span>
    </div>
    @if (purchases.length > 5) {
    <button class="btn view-all-btn d-flex align-items-center gap-1" (click)="viewAllPurchases(purchasesModal)">
      View all Purchases <fa-icon [icon]="faChevronRight" style="font-size: 10px;"></fa-icon>
    </button>
    }
  </div>

  <div class="table-box">
    <table class="table custom-table border-0 mb-0">
      <thead>
        <tr>
          <th class="fw-smbold border-0">Top Purchased SKUs</th>
          <th class="text-end fw-smbold border-0">Units</th>
          <th class="text-end fw-smbold border-0">Value</th>
        </tr>
      </thead>
      <tbody>
        <!-- Loader State -->
        @if (loader) {
        <tr>
          <td colspan="3" class="text-center py-4 border-0">
            <app-loader [loadingIcon]="loader"></app-loader>
          </td>
        </tr>
        }

        <!-- Error State -->
        @if (!loader && errMsg) {
        <tr>
          <td colspan="3" class="text-center py-4 border-0">
            <p class="text-danger mb-0 small fw-bold">{{ errMsg }}</p>
          </td>
        </tr>
        }

        <!-- Data State -->
        @if (!loader && !errMsg) {
        @for (item of purchases | slice:0:5; track item) {
        <tr>
          <td class="td-col-1 border-0">{{ item.sku }}</td>
          <td class="text-end td-col-2 fw-smbold border-0">
            @if (item.units !== null) {
            {{ item.units | number }}
            } @else {
            -
            }
          </td>
          <td class="text-end td-col-3 fw-bold border-0">
            @if (item.value !== null) {
            {{ item.value | number }}
            } @else {
            -
            }
          </td>
        </tr>
        }
        }
      </tbody>
    </table>
  </div>
</div>

<!-- Modal Template -->
<ng-template #purchasesModal let-modal>
  <div class="modal-header border-0 pb-0">
    <h5 class="fw-bold mb-0 main-heading">All Purchases</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>

  <div class="modal-body p-2 p-md-4">
    <div class="table-responsive table-container pe-md-2 pe-1" style="max-height: 60vh; overflow-y: auto;"
      infinite-scroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="300"
      [scrollWindow]="false" (scrolled)="onScroll()">
      <table class="table custom-table border-0 mb-0">
        <thead style="position: sticky; top: 0; background: white; z-index: 1;">
          <tr>
            <th class="fw-smbold border-0">Top Purchased SKUs</th>
            <th class="text-end fw-smbold border-0">Units</th>
            <th class="text-end fw-smbold border-0">Value</th>
          </tr>
        </thead>
        <tbody>
          @if (purchases.length > 0) {
          @for (item of purchases; track item) {
          <tr>
            <td class="td-col-1 border-0">{{ item.sku }}</td>
            <td class="text-end td-col-2 fw-smbold border-0">
              @if (item.units !== null) {
              {{ item.units | number }}
              } @else {
              -
              }
            </td>
            <td class="text-end td-col-3 fw-bold border-0">
              @if (item.value !== null) {
              {{ item.value | number }}
              } @else {
              -
              }
            </td>
          </tr>
          }
          }
          @if (purchases.length === 0) {
          <tr>
            <td colspan="3" class="text-center py-4 border-0">
              <p class="text-muted mb-0 small fw-bold">No purchase data found.</p>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</ng-template>
